/**
 * @desc 油卡总览-数值统计
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean<defs.ElectronicOilCardStatistics>>> {
  return fetch({
    url: config.API_HOST + '/card/overview/total',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
